import React from 'react';
import TitleBase from './TitleBase';
import { TTitle } from './types';

const Title1 = ({ as = 'h1', ...rest }: TTitle) => <TitleBase {...rest} as={as} kind="title-1" />;

export default Title1;
